export default {
  // 頁面標題與副標題
  title: '我的寵物',
  subtitle: '您有 {{count}} 隻寵物',
  
  // 載入與錯誤狀態
  checkingAuth: '正在驗證身份...',
  loadingPets: '正在載入您的寵物資料...',
  fetchErrorTitle: '無法載入寵物資料',
  retry: '重試',
  
  // 空狀態
  noPetsTitle: '還沒有寵物',
  noPetsSubtitle: '開始建立您的第一個寵物檔案',
  addFirstPet: '新增第一隻寵物',
  
  // 動作按鈕
  addPet: '新增寵物',
  edit: '編輯',
  delete: '刪除',
  share: '分享',
  shareNow: '立即分享',
  preview: '預覽',
  viewFullDetails: '查看完整資料',
  
  // 視圖模式
  gridView: '格狀顯示',
  listView: '列表顯示',
  
  // 統計資料
  statistics: '統計資料',
  totalPets: '寵物總數',
  registeredPets: '已註冊',
  averageAge: '平均年齡',
  allPets: '所有寵物',
  weeklyAdded: '本週新增',
  recentlyAdded: '最近新增',
  mostCommonType: '最常見類型',
  
  // 搜尋與篩選
  searchPlaceholder: '搜尋寵物名稱、品種或類型...',
  sortByName: '按名稱排序',
  sortByCreated: '按建立日期排序',
  sortByType: '按類型排序',
  showingResults: '顯示 {{current}} / {{total}} 隻寵物',
  noMatchingPets: '沒有符合的寵物',
  searchKeyword: '搜尋關鍵字：{{keyword}}',
  typeFilter: '類型篩選：{{type}}',
  clearFilters: '清除篩選條件',
  
  // 寵物資訊
  unnamedPet: '未命名寵物',
  unknownBreed: '未知品種',
  yearsOld: '歲',
  nextFeeding: '下次餵食',
  nextMedication: '下次用藥',
  nextVetVisit: '下次獸醫',
  location: '位置',
  home: '家',
  notSet: '未設定',
  
  // 刪除確認
  deleteError: '刪除失敗，請稍後再試',
  deleteSuccess: '寵物已成功刪除'
};